
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/[username]/[nonprofitSlug]",
      function () {
        return require("private-next-pages/user/[username]/[nonprofitSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/[username]/[nonprofitSlug]"])
      });
    }
  